import { render, staticRenderFns } from "./support.vue?vue&type=template&id=2c4c5ba0&scoped=true&"
import script from "./support.vue?vue&type=script&lang=ts&"
export * from "./support.vue?vue&type=script&lang=ts&"
import style0 from "./support.vue?vue&type=style&index=0&id=2c4c5ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c5ba0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavMenu: require('/var/lib/jenkins/workspace/e-world-nuxt/components/navMenu.vue').default,MypagePageLayout: require('/var/lib/jenkins/workspace/e-world-nuxt/components/mypage/pageLayout.vue').default,EUpload: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/upload.vue').default,EField: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/field.vue').default,EInput: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/input.vue').default,EButton: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/button.vue').default,EDaumPostcode: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/daumPostcode.vue').default,AntModal: require('/var/lib/jenkins/workspace/e-world-nuxt/components/antModal.vue').default,ESectionTable: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/sectionTable.vue').default,EPrivacyAgree: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/privacyAgree.vue').default})
